import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement, useState } from 'react';
import { useHistory } from 'react-router';
import { Card, Page, Spinner, TextButton, Typography } from 'seagull';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { routes } from '~/constants';
import { useIoContext, useStore } from '~/contexts';
import { useOnMount } from '~/hooks/useOnMount';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import { helpArticles } from '~/utils/helpArticles';
import { loadZapierJsAndCss } from '~/utils/zapier-elements';
import styles from './SlackViaZapierPage.module.scss';
var LoadZapierStatus = /*#__PURE__*/ function(LoadZapierStatus) {
    LoadZapierStatus["Loading"] = "loading";
    LoadZapierStatus["Success"] = "success";
    LoadZapierStatus["Error"] = "error";
    return LoadZapierStatus;
}(LoadZapierStatus || {});
const uiMap = {
    ["success"]: function SuccessState() {
        const userEmail = useStore(selectors.user.email);
        const userFirstName = useStore(selectors.user.firstName);
        const userLastName = useStore(selectors.user.lastName);
        return /*#__PURE__*/ _jsx(Card, {
            bi: {
                name: 'slack_via_zapier_card'
            },
            autoHeight: true,
            padding: "m",
            children: /*#__PURE__*/ _jsx("zapier-zap-templates", {
                "data-testid": "zapier-zap-templates",
                "sign-up-email": userEmail,
                "sign-up-first-name": userFirstName,
                "sign-up-last-name": userLastName,
                "client-id": "ieG0DJXKRhT4gI3t1DfefyH3YmooofjSMrEecI1t",
                theme: "light",
                ids: "1308170,1230341,1223023,1307798,1306468,1388914,1233302,1616853",
                limit: 5,
                "use-this-zap": "show"
            })
        });
    },
    ["loading"]: function LoadingState() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.centeredBox,
            "data-testid": "zapier-loading",
            children: /*#__PURE__*/ _jsx(Spinner, {})
        });
    },
    ["error"]: function ErrorState() {
        const { t: slackTexts } = useLocaleKeys('integrations.slack');
        const { locationReload } = useIoContext();
        return /*#__PURE__*/ _jsx("div", {
            className: styles.centeredBox,
            "data-testid": "zapier-error",
            children: /*#__PURE__*/ _jsxs(Typography, {
                children: [
                    slackTexts.errorOccurred(),
                    ' ',
                    /*#__PURE__*/ _jsx(TextButton, {
                        onClick: ()=>locationReload(),
                        children: slackTexts.reload()
                    }),
                    ' ',
                    slackTexts.toTryAgain()
                ]
            })
        });
    }
};
export default function SlackViaZapierPage() {
    const { t: texts } = useLocaleKeys('integrations.availableApps.slack');
    const { t: slackTexts } = useLocaleKeys('integrations.slack');
    const { injectScriptOrLink } = useIoContext();
    const history = useHistory();
    const [loadZapierStatus, setLoadZapierStatus] = useState(null);
    useOnMount(()=>{
        setLoadZapierStatus("loading");
        loadZapierJsAndCss({
            injectScriptOrLink
        }).then(()=>setLoadZapierStatus("success")).catch(()=>setLoadZapierStatus("error"));
    });
    return /*#__PURE__*/ _jsx(Page, {
        testId: "slack-via-zapier",
        header: texts.recommendedZaps(),
        subheader: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                "".concat(slackTexts.automateWorkflows(), " "),
                /*#__PURE__*/ _jsx(ExternalLinkButton, {
                    openInNewTab: true,
                    href: helpArticles.anchorZaps(),
                    bi: {
                        name: 'slack_anchor_zaps_read_more'
                    },
                    children: slackTexts.readMore()
                })
            ]
        }),
        onClickBack: ()=>history.push(routes.availableApps),
        children: loadZapierStatus && /*#__PURE__*/ createElement(uiMap[loadZapierStatus])
    });
}
